import Header from "../components/Header";
import Footer from "../components/Footer";

const CreditRepair = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header showAdminLink />

      <main className="pt-40 pb-16 px-4 sm:px-6 lg:px-8">
        <section style={{ maxWidth: 900, margin: "0 auto", padding: "40px 20px", fontFamily: "Arial, sans-serif" }}>
          <h1 style={{ fontSize: 32, color: "#1b365d", marginBottom: 16 }}>Credit Repair</h1>

          <p style={{ fontSize: 16, lineHeight: 1.6, color: "#333", marginBottom: 24 }}>
            WMJ Enterprise Services LLC provides <strong>credit repair services</strong> focused on identifying,
            disputing, and addressing inaccurate, incomplete, or unverifiable items appearing on consumer
            credit reports in accordance with applicable consumer protection laws.
          </p>

          <h3 style={{ fontSize: 22, color: "#1b365d", marginBottom: 12 }}>What we help with</h3>

          <ul style={{ fontSize: 16, lineHeight: 1.8, color: "#333", paddingLeft: 20 }}>
            <li>Reviewing credit reports for errors or questionable items</li>
            <li>Assisting with disputes of inaccurate, incomplete, or unverifiable information</li>
            <li>Communicating with credit bureaus and data furnishers as part of the dispute process</li>
            <li>Supporting credit profile improvement through documented credit repair actions</li>
            <li>Preparing credit profiles for future opportunities (auto, home, funding)</li>
          </ul>

          <div style={{ marginTop: 32, padding: 16, borderLeft: "4px solid #c9a227", background: "#f8f9fb" }}>
            <p style={{ fontSize: 14, color: "#555", margin: 0 }}>
              <strong>Disclaimer:</strong> WMJ Enterprise Services LLC does not provide financial coaching,
              financial advice, or credit counseling. Services are limited strictly to credit repair and
              dispute assistance.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default CreditRepair;
